import { IHttpApi } from '@cian/http-api';

import { assertResponseError } from './assert';
import { ICanUserCreateRequestResponse } from '../../repositories/newbuilding-broker/entities/can_user_create_request/CanUserCreateRequestResponse';
import {
  fetchCanUserCreateRequest,
  TCanUserCreateRequestResponse,
} from '../../repositories/newbuilding-broker/v1/can-user-create-request';

interface IParams {
  httpApi: IHttpApi;
}

export const canUserCreateRequest = async ({ httpApi }: IParams): Promise<ICanUserCreateRequestResponse> => {
  const result: TCanUserCreateRequestResponse = await fetchCanUserCreateRequest({ httpApi });

  assertResponseError(result);

  return result.response;
};
